/* @flow */

import Immutable from 'immutable';
import { SidePanelConstants } from '../constants/sidepanel_constants';
import { SharedConstants } from '../constants/shared_constants';

const sidepanelInitialState = Immutable.Map({
  query: '',
  isCollapsed: false,
  isLoadingSearch: false,
  activeId: 0,
  searchResults: Immutable.Map({
    all: Immutable.List([]),
    page: Immutable.Map({}),
  })
});

function sidepanelReducer(state: Immutable.Map = sidepanelInitialState, action: Object): Immutable.Map {
  switch (action.type) {
    case SharedConstants.SHARED_PURGE: {
      return sidepanelInitialState;
    }

    case SidePanelConstants.SIDEPANEL_SET_SEARCH_RESULTS_NONE: {
      return state.set('query', action.query)
        .setIn(['searchResults', 'all'], Immutable.List([]))
        .setIn(['searchResults', 'page'], Immutable.Map({}))
    }
    case SidePanelConstants.SIDEPANEL_SET_SEARCH_RESULTS: {
      return state.set('query', action.query)
        .setIn(['searchResults', 'all'], action.allResults)
        .setIn(['searchResults', 'page', 'number'], 1)
        .setIn(['searchResults', 'page', 'results'], action.pageResults)
        .setIn(['searchResults', 'page', 'start'], 1)
        .setIn(['searchResults', 'page', 'end'], action.pageEnd);
    }
    case SidePanelConstants.SIDEPANEL_UPDATE_SEARCH_PAGE: {
      return state.setIn(['searchResults', 'page', 'number'], action.pageNumber)
        .setIn(['searchResults', 'page', 'results'], action.pageResults)
        .setIn(['searchResults', 'page', 'start'], action.pageStart)
        .setIn(['searchResults', 'page', 'end'], action.pageEnd);
    }
    case SidePanelConstants.SIDEPANEL_CLEAR_SEARCH: {
      return state.set('query', '')
        .setIn(['searchResults', 'all'], Immutable.List([]))
        .setIn(['searchResults', 'page'], Immutable.Map({}))
        .set('isCollapsed', false);
    }
    case SidePanelConstants.SIDEPANEL_TOGGLE_COLLAPSED: {
      return state.set('isCollapsed', !(state.get('isCollapsed')));
    }
    case SidePanelConstants.SIDEPANEL_LOADING_START: {
      return state.set('isLoading', true);
    }
    case SidePanelConstants.SIDEPANEL_LOADING_END: {
      return state.set('isLoading', false);
    }
    case SidePanelConstants.SIDEPANEL_SET_ACTIVEID: {
      return state.set('activeId', action.activeId);
    }
  }
  return state;
}

export {
  sidepanelInitialState,
  sidepanelReducer
};
